export default "__VITE_ASSET__DH06hPUW__"